import { createContext, useContext } from 'react';

import type { useCheckboxGroupState } from './useCheckboxGroupState';

export type CheckboxGroupState = ReturnType<typeof useCheckboxGroupState>;
export const CheckboxGroupContext = createContext<CheckboxGroupState | null>(
  null
);
export const useCheckboxGroupContext = () => {
  return useContext(CheckboxGroupContext);
};
